import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { UserDocMappingComponent } from './user-doc-mapping/user-doc-mapping.component';
import { ViewLogInsComponent } from './view-log-ins/view-log-ins.component';
import {AddUsersComponent } from './add-users/add-users.component';
import { SearchUsersComponent } from './search-users/search-users.component';
import { AssignDocumentComponent } from './assign-document/assign-document.component';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { BulkUpdateUsersComponent } from './bulk-update-users/bulk-update-users.component'
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { ViewUserDocComponent } from './view-user-doc/view-user-doc.component';
import { AddCommissionDocComponent } from './add-commission-doc/add-commission-doc.component';
import { NewUsersComponent } from './new-users/new-users.component';

const routes: Routes = [
  {path:'manage-users', component:ManageUsersComponent,canActivate:[AuthGaurdService] , data: { roles: ['ADMIN', 'Admin'] }},
  {path:'user-doc-mapping', component:UserDocMappingComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'view-logins', component:ViewLogInsComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'add-users', component:AddUsersComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'new-users', component:NewUsersComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'search-users', component:SearchUsersComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'assign-document', component:AssignDocumentComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'pending-users', component:PendingUsersComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'bulk-update-users', component:BulkUpdateUsersComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'view-user-doc', component:ViewUserDocComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }},
  {path:'add-commission-doc', component:AddCommissionDocComponent,canActivate:[AuthGaurdService], data: { roles: ['ADMIN', 'Admin'] }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PersonnelRoutingModule { }
